import { http } from '@/core/helpers/http.helper';

export class ColorThemeService {
   async getColorThemes() {
      return http.get('/color-themes').then((response) => response.data);
   }

   async getColorTheme() {
      throw Error('Method not implemented');
   }

   async postColorTheme() {
      throw Error('Method not implemented');
   }

   async putColorTheme() {
      throw Error('Method not implemented');
   }

   async deleteColorTheme() {
      throw Error('Method not implemented');
   }
}
